import { createIcon } from '../icon'
import GoogleIcon from '@/components/atoms/svg/GoogleIcon'

export const GoogleIconDefault = createIcon(GoogleIcon)
